const moment = require('moment');
require('moment/locale/fr');

export default moment;
